import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from 'utils/config';
import { callApi, showSweetAlert } from 'utils/utils';
import { object, string, number } from 'yup';
import { Label, Row, Col } from 'reactstrap';
import moment from 'moment';
import YupValidator from 'utils/YupValidator';
import FieldText from 'components/Controls/FieldText';
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import FieldDropdown from 'components/Controls/FieldDropdown';
import FieldCalendar from 'components/Controls/FieldCalendar';
import FieldAutoComplete from 'components/Controls/FieldAutoComplete';
import FieldTextArea from 'components/Controls/FieldTextArea';

const MiscellaneousQueriesAdd = (props) => {
  const {t, i18n} = useTranslation(['miscellaneousQueries', 'common']);
  const [equipments, setEquipments] = useState([]);
  const [brands, setBrands] = useState([]);
  const [commandProcedure, setCommandProcedure] = useState(null);
  const [queryDescription, setQueryDescription] = useState(null);
  const [errors, setErrors] = useState([]);
  const [claTipoEquipo, setClaTipoEquipo] = useState(null);  
  const [claMarcaEquipo, setClaMarcaEquipo] = useState(null);  

  useEffect(() => {
    GetEquipments();
    GetBrands();
  }, [])

  const GetEquipments = () => {
    const urlWebService = `${config.UrlApiProject}IT/GetEquipmentTypes`;
    const paramsService = {};

    callApi(urlWebService, 'GET', paramsService, (response) => {
      setEquipments([]);
    });
  }

  const GetBrands = () => {
    const urlWebService = `${config.UrlApiProject}IT/GetEquipmentBrands`;
    const paramsService = {};

    callApi(urlWebService, 'GET', paramsService, (response) => {
      setBrands([]);
    });
  }
 
  const onChangeCommandProcedure = (e) => {
    const newErrors = {...errors};
    delete newErrors.commandProcedure;
    setErrors(newErrors);
    setCommandProcedure(e.target.value === '' ? null : e.target.value);
  }

  const onChangeEquipmentFilter = (e) => {
    setClaTipoEquipo(e.value === undefined ? null : e.value);
  }

  const onChangeBrandFilter = (e) => {
    setClaMarcaEquipo(e.value === undefined ? null : e.value);
  }

  const onChangeQueryDescription = (e) => {
    const newErrors = {...errors};
    delete newErrors.queryDescription;
    setErrors(newErrors);
    setQueryDescription(e.target.value.trim());
  }

  return (
    <>
      <Row className='p-fluid pt-2'>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Row className='align-items-start'>
            <Col xs={12} sm={12} md={12} lg={12}>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className='p-field'>
                <Label>{t('miscellaneousQueries:Library')}</Label>
                <FieldDropdown
                  id='tipoEquipo'
                  name='tipoEquipo'
                  value={claTipoEquipo}
                  options={equipments}
                  optionValue='ClaTipoEquipo'
                  optionLabel='NomTipoEquipo'
                  onChange={onChangeEquipmentFilter}
                >
                </FieldDropdown>
              </div>
            </Col>
          </Row>
          <Row className='align-items-start'>
            <Col xs={12} sm={612} md={12} lg={12}>
              <div className='p-field'>
                <Label>{t('miscellaneousQueries:Query')}</Label>
                <FieldDropdown
                  id='marcaEquipo'
                  name='marcaEquipo'
                  value={claMarcaEquipo}
                  options={brands}
                  optionValue='ClaMarcaEquipo'
                  optionLabel='NomMarcaEquipo'
                  onChange={onChangeBrandFilter}
                >
                </FieldDropdown>
              </div>
            </Col>
          </Row>
          <Row className='align-items-start'>
            <Col xs={12} sm={12} md={12} lg={12} className='p-field'>
              <Label>{`${t('miscellaneousQueries:CommandProcedure')} *`}</Label>
              <FieldText
                id='commandProcedure'
                name='commandProcedure'
                value={commandProcedure}
                onChange={onChangeCommandProcedure}
                errors={errors}
              >
              </FieldText>
            </Col>
          </Row>
          <Row className='align-items-start'>
            <Col xs={12} sm={12} md={12} lg={12} className='p-field'>
              <Label>{`${t('miscellaneousQueries:QueryDescription')} *`}</Label>
              <FieldTextArea  
                name="QueryDescription"
                value={queryDescription}
                rows={5}
                onChange={onChangeQueryDescription}
                maxLength={3000}
                errors={errors}
              /> 
            </Col> 
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default MiscellaneousQueriesAdd;